/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';


export interface RolloutTypeCloudProviderVersionsSpec { 
    cloud_provider: CloudProviderEnum;
    /**
     * List of supported Deployment versions.
     */
    versions: Array<string>;
}
export namespace RolloutTypeCloudProviderVersionsSpec {
}


